import { type ReactNode, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { initializeDeepLinkHandler } from "../utils/deepLinkHandler";
import { Platform } from "../utils/platform";

interface DeepLinkProviderProps {
  children: ReactNode;
}

/**
 * Provider that initializes deep link handling for the mobile app.
 * This should be mounted at the root level and never unmount to ensure
 * deep link listeners persist throughout the app lifecycle.
 */
export function DeepLinkProvider({ children }: DeepLinkProviderProps) {
  const history = useHistory();

  useEffect(() => {
    if (!Platform.isMobile) {
      return undefined;
    }

    const cleanup = initializeDeepLinkHandler((path: string) => {
      // path is already normalised to "/pathname?search" by normaliseDeepLink
      history.push(path);
    });

    return () => {
      cleanup();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - only run once on mount

  return children;
}
